import React from 'react';
import TopContent from 'components/TopContent';
import Writeup from 'components/Writeup';
import Team from 'components/Team';
import BottomContent from 'components/BottomContent';
import ProductRoadmap from 'components/ProductRoadmap';

import './Home.scss';

function Home() {
  return (
    <div className="mintContainer">
      <TopContent />
      <Writeup />
      <Team />
      <BottomContent />
      <ProductRoadmap />
    </div>
  );
}

export default Home;
